import { stageIsClosedOrCancelled, stageIsFinalised, WorkOrder } from '@jms/model';

/**
 * Client half of the server's `stageAllowsManage` (`stage.item.security.capability.ts:24`) — same
 * terms, same shared helpers, so a row action is never offered where the command would refuse it on
 * stage grounds. Takes a stage, not a screen selection, because legacy asked this per row off
 * `code.workOrder.status` (`embedded.codes.component.ts:697`).
 *
 * `canManage` is a parameter so a caller can fold in facts the server rule has no term for, such as an
 * archived job source.
 *
 * An unknown stage is never writable: the helpers read a missing stage as neither closed nor finalised,
 * so it would otherwise come back as writable.
 */
export function isStageItemWritable(stage: WorkOrder, canManage: boolean, canModifyFinalised: boolean): boolean {

  if (!stage) return false;

  return !!canManage && !stageIsClosedOrCancelled(stage) && (!stageIsFinalised(stage) || !!canModifyFinalised);
}
